import {detail_by_token_joker} from "./detail_by_token_joker";
import {common_utils} from "../common/common_utils";
import {game_3004} from "../esports/game_3004";
import {game_3008} from "../esports/game_3008";
import {game_3000} from "../esports/game_3000";
import {game_3001} from "../esports/game_3001";
import {game_3003} from "../esports/game_3003";
import {game_3002} from "../esports/game_3002";
import {game_3011, game_3011_12_13} from "../esports/game_3011_12_13";
import {game_3200} from "../esports/game_3200";

function detail_by_token_rocket()
{

}

detail_by_token_rocket.readDataValue = function(this1, data)
{
    this1.recordId = data.recordId
    this1.rocket = true

    common_utils.readDataValue(this1,data,true,true);
    this1.betamount = data.bet.toFixed(2)

    this1.parachutehigh = data.detail.JumpHeight
    this1.parachutemoney = data.win.toFixed(2)
    this1.BombHeight = data.detail.BombHeight
    this1.isTotalWin= common_utils.getValue(data,"winCny") > 0;

    if (this1.gameid == 3001) {
      this1.balloon_size = data.detail.Odds
      this1.balloon_result = (data.detail.TotalWin / 100).toFixed(2)
      this1.winValueTotal = game_3001.getWinInfo(data.detail);
      if(data.detail.TotalWin>0)
      {
        this1.winValueTip = this1.$t(`lang.str_3001_win_value_tip`);
      }else
      {
        this1.winValueTip = this1.$t(`lang.str_3001_win_value_tip2`);
      }

    }
    if(this1.gameid == 3000)
    {
      this1.betInfos  = data.detail.BetInfos;
      //console.log(this1.betInfos )
      let WinInfo = game_3000.getWinInfo(this1,this1.betInfos);
      this1.winValueTotal = WinInfo[0];
      this1.winValueTip =  WinInfo[1];
    }

    if (this1.gameid == 3002) {
      this1.balloon_size = data.detail.JumpHeight
      this1.balloon_result = (data.detail.TotalWin / 100).toFixed(2)
      this1.winValueTotal = game_3002.getWinInfo(data.detail);
      this1.winValueTip = this1.$t(`lang.str_3002_win_value_tip`);
    }

    if (this1.gameid == 3003) {
      this1.hit_number = data.detail.HitNumber
      this1.bet_number = data.detail.BetNumber
      this1.odds = data.detail.Odds
      this1.winValueTotal = game_3003.getWinInfo(data.detail);
      this1.winValueTip = this1.$t(`lang.str_3003_win_value_tip`);

    }

    if (this1.gameid == 3004) {
      this1.bet_number = data.detail.BetNumber
      this1.odds = data.detail.Odds
      this1.mapList = data.detail.Gems
      let winAmount = 0;
      let win = data.detail.Win;
      let bet = data.detail.Bet;
      this1.mapListDetail = game_3004.getArrayGroup(this1.mapList);
      this1.describe_message = this1.$t(`lang.str_3004_describe_message`);
      this1.describe_title = this1.$t(`lang.str_describe_title`);
      this1.winValueTip = this1.$t(`lang.str_3004_win_value_tip`);
      if(win == null)
      {
         win = 0;
      }
      winAmount = (( win - bet)/ 100).toFixed(2);
      this1.winValueTotal = "("+this1.betamount+" x "+this1.odds + ")" +" - "+this1.betamount +" = "+ winAmount;

    }

    if (data.gameId == 3005 || data.gameId == 3006 || data.gameId == 3007 || data.gameId == 3008
      || data.gameId == 3009 || data.gameId == 3010 || data.gameId == 3011 || data.gameId == 3012
      || data.gameId == 3013)
    {
      // this1.username = data.loginName
      // this1.gameid = data.gameId
      // this1.profit = data.win - data.bet
      // this1.betamount = data.bet
      // this1.betTime = data.startTime
      common_utils.readDataValue(this1,data);

      this1.hasfree = false
      this1.hasbonuswin = false

      if (data.gameId == 3011 || data.gameId == 3012|| data.gameId == 3013)
      {
        this1.winpos = data.detail
        this1.winValueTotal = game_3011_12_13.getWinInfo(data.detail)
        this1.winValueTip = this1.$t(`lang.str_3011_win_value_tip`);
      }
      else if (data.gameId == 3008)
      {
        switch(data.detail.BetType) {
          case 1:
            this1.geValue = this1.$t(`lang.str_mylp1`)
            break
          case 2:
            this1.geValue = this1.$t(`lang.str_mylp2`)
            break
          default:
            this1.geValue = this1.$t(`lang.str_mylp0`)
            break
        }
        switch(data.detail.WinTpye) {
          case 1:
            this1.winType = this1.$t(`lang.str_mylp1`) + ' ' + data.detail.WinFreeTimes
            break
          case 2:
            this1.winType = this1.$t(`lang.str_mylp2`)
            break
          default:
            this1.winType = (data.detail.Bet * data.detail.WinOdds / 100).toFixed(2)
            break
        }
        this1.bet = data.detail.Bet
        this1.describe_title = this1.$t(`lang.str_describe_title`)
        this1.describe_message = game_3008.describe_message(this1);
        this1.odds = data.detail.WinOdds+"x";
        this1.winIndex = data.detail.WinIndex;

        let WinOdds = common_utils.getValue(data.detail,"WinOdds");
        let Win = common_utils.getValue(data.detail,"Win");
        if(data.detail.WinTpye !=1||data.detail.WinTpye!=2)
        {
          this1.winValueTip = this1.$t(`lang.str_3008_win_value_tip`);
          this1.winValueTotal = "("+common_utils.getValueFixed(this1.bet)+" x "+WinOdds+")" +" - "+common_utils.getValueFixed(this1.bet)
            +" = "+ common_utils.getValueFixed(Win) + " - "+common_utils.getValueFixed(this1.bet)
            +" = "+ common_utils.getValueFixed(Win-this1.bet);
        }else
        {
          this1.winValueTip = game_3008.getWinIndex(this1,this1.winIndex);
          this1.winValueTotal = this1.winType;
        }

      }
      else if (data.gameId == 3007)
      {
        this1.bet = data.detail.Bet
        this1.tzfx = data.detail.BetRisk
        this1.tzds = data.detail.BetLines
        this1.jgbs = data.detail.WinOdd
        this1.jg = data.detail.Win - data.detail.Bet
        let Win = data.detail.Win;
        let Odds = data.detail.WinOdd;
        this1.winValueTip = this1.$t(`lang.str_3007_win_value_tip`);
        this1.winValueTotal = "("+common_utils.getValueFixed(this1.bet)+" x "+Odds+")" +" - "+common_utils.getValueFixed(this1.bet)
          +" = "+ common_utils.getValueFixed(Win) +" - "+common_utils.getValueFixed(this1.bet)
          +" = "+ common_utils.getValueFixed(this1.jg);
      }
      else if (data.gameId == 3009)
      {
        this1.bet = data.detail.Bet
        this1.tzfx = data.detail.Risk
        this1.tzds = data.detail.Seg
        this1.jgbs = data.detail.Odds
        let Win = data.detail.Win;
        let Odds = data.detail.Odds;
        this1.jg = data.detail.Win - data.detail.Bet

        this1.winValueTip = this1.$t(`lang.str_3009_win_value_tip`);
        this1.winValueTotal = "("+common_utils.getValueFixed(this1.bet)+" x "+Odds+")" +" - "+common_utils.getValueFixed(this1.bet)
          +" = "+ common_utils.getValueFixed(Win) +" - "+common_utils.getValueFixed(this1.bet)
          +" = "+ common_utils.getValueFixed(this1.jg);

      }
      else if (data.gameId == 3005)
      {
        this1.bet = data.detail.Bet
        this1.tzbs = data.detail.BetOdds
        this1.jgbs = data.detail.Odds
        let Win = data.detail.Win;
        this1.jg = data.detail.Win - data.detail.Bet
        this1.winValueTip = this1.$t(`lang.str_3005_win_value_tip`);
        if(data.detail.Odds > data.detail.BetOdds)
        {
          this1.winValueTotal = "("+common_utils.getValueFixed(this1.bet)+" x "+this1.tzbs+")"
            +" - "+common_utils.getValueFixed(this1.bet)+" = "+ common_utils.getValueFixed(Win)
            +" - "+common_utils.getValueFixed(this1.bet) +" = "+ common_utils.getValueFixed(this1.jg);
        }else
        {
          this1.winValueTotal = "("+common_utils.getValueFixed(this1.bet)+" x "+0.00+")"
            +" - "+common_utils.getValueFixed(this1.bet)+" = "+ common_utils.getValueFixed(Win)
            +" - "+common_utils.getValueFixed(this1.bet) +" = "+ common_utils.getValueFixed(this1.jg);
        }

      } else {
        this1.mapList = data.detail.Bets
        this1.geValue = data.detail.Win
        this1.winpos = data.detail.pos
      }
    }
    if(this1.gameid == 3200||this1.gameid == 3201)
    {
      console.log("3200")
      this1.CrashX = data.detail.CrashX;
      if(data.detail.BetInfos)
      {
        this1.betInfos = data.detail.BetInfos;
      }else
      {
        this1.betInfos = [data.detail.BetInfo];
      }

      if(this1.betInfos)
      {
        if(this1.betInfos.length>0)
        {
          this1.Currency = this1.betInfos[0].Currency
        }
        else
        {
          this1.Currency = this1.betInfos.Currency
        }
        this1.RoundId = data.detail.RoundId;
      }
      let WinInfo = game_3200.getWinInfo(this1,this1.betInfos);
      this1.winValueTotal = WinInfo[0];
      this1.winValueTip =  WinInfo[1];
    }
}

export {
  detail_by_token_rocket
};



// WEBPACK FOOTER //
// ./src/components/data/detail_by_token_rocket.js